<template>
  <div class="table-responsive">
    <table class="table table-sm">
      <thead>
        <tr>
          <th>#</th>
          <th v-for="column in columns" :key="column">{{ column }}</th>
          <slot name="actionsHeaders"></slot>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="row.id">
          <td>{{ index + 1 }}</td>
          <td v-for="column in columns" :key="column">{{ row[column] }}</td>
          <slot name="actions" :row="row" :index="index"></slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
export default {
  props: ['columns', 'rows'],
  setup(props) {
    return {
    }
  }

}
</script>

<style scoped>

</style>
